// Types
import React from 'react';
import { DropdownMenuCard, type IOption } from 'components/Card';
import _ from 'lodash';
import { parsedCustomerSignatureSelector } from 'slices/auth.slice';
/// Slices
import {
  fetchReservationTemplates,
  reservationTemplatesSelector,
} from 'slices/reservationTemplate.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { timeRuleMapSelector } from 'slices/timeRule.slice';
import { ETemplateType } from '@timeedit/types/lib/enums';
import type { TReservationMode } from '@timeedit/types/lib/types';
// Components
import { TEDrawerSection } from '@timeedit/ui-components';

export interface PaddingRuleInfoProps {
  data: TReservationMode;
  onChange: (key: string, value: any) => void;
}

const PaddingRuleInfo = (props: PaddingRuleInfoProps) => {
  const { data, onChange } = props;

  const allReservationTemplate =
    useAppSelector(reservationTemplatesSelector) || [];
  const timeRulesMapping = useAppSelector(timeRuleMapSelector);
  const customerSignature = useAppSelector(parsedCustomerSignatureSelector);
  const dispatch = useAppDispatch();

  const reservationTemplatesOptions = React.useMemo(() => {
    if (allReservationTemplate && allReservationTemplate.length > 0) {
      const listOptions: IOption[] = [];
      allReservationTemplate?.forEach((reservationTemplate) => {
        if (
          reservationTemplate.templateType !== ETemplateType.INFO_RESERVATION
        ) {
          const timeRuleName = _.get(
            timeRulesMapping,
            [reservationTemplate.timeRule, 'name'],
            ''
          );
          listOptions.push({
            key: String(reservationTemplate.id),
            label: `${reservationTemplate.name} [${timeRuleName}]`,
            url: `/${customerSignature}/configuration/reservation-templates?item1=${reservationTemplate.id}`,
          });
        }
      });
      return listOptions;
    } else {
      dispatch(fetchReservationTemplates());
    }
    return [];
  }, [allReservationTemplate, timeRulesMapping, customerSignature]);

  return (
    <TEDrawerSection label="Reservation templates">
      <DropdownMenuCard
        title="Reservation templates"
        selectedKeys={data?.reservationTemplates?.map(String) || []}
        options={reservationTemplatesOptions}
        onChange={(values) => {
          onChange('reservationTemplates', values.map(Number));
        }}
        data-testid="add-reserv-template"
      />
    </TEDrawerSection>
  );
};

export default PaddingRuleInfo;
